<section class="container">
<div #container style="width:100%; text-align:center;margin:0; padding:0;" >
    <ng-image-slider [images]="imageObject" #nav imagePopup="true" [infinite]="false" [manageImageRatio]=true
        [autoSlide]="1" [animationSpeed]="0.1" [imageSize]="{width: container.style.width, space:0}" slideImage="1">
    </ng-image-slider>
    <h4>
        {{RssData?.rss.channel[0].title[0]}}
    </h4>
    <div class="col-lg-3"> &nbsp;</div>
    <div class="col-lg-6 pt-10 text-left">
        <ul>
            <li *ngFor="let o of RssData?.rss.channel[0].item"><a href="{{o.link[0]}}">{{o.title[0]}}</a></li>
        </ul>
    </div>
    <div class="col-lg-3"></div>
</div>
</section>
<!-- Total Item: {{RssData?.rss.channel[0].item.length}} -->